document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('section.js-readmore[data-section-type="custom-content"]').forEach(function(section){

    const container = section.querySelector('.rich-text__text');
    if (!container) return;

    // On prend le 1er paragraphe "utile" (pas vide / pas &nbsp;)
    const paragraphs = Array.from(container.querySelectorAll('p'));
    const firstP = paragraphs.find(p => {
      const txt = (p.textContent || "").replace(/\u00A0/g, " ").trim();
      return txt.length > 0;
    });

    if (!firstP) return;

    // On crée le wrapper caché
    const hidden = document.createElement("div");
    hidden.className = "readmore-hidden";

    // Déplacer UNIQUEMENT les noeuds après le 1er paragraphe dans hidden
    let node = firstP.nextSibling;
    while (node) {
      const next = node.nextSibling;
      hidden.appendChild(node);
      node = next;
    }

    // Si rien à cacher, on ne met pas de bouton
    if (!hidden.childNodes.length) return;

    // On insère le wrapper caché juste après le 1er paragraphe
    firstP.insertAdjacentElement("afterend", hidden);

    // Langue auto (FR/EN)
    const lang = (document.documentElement.lang || "fr").toLowerCase();
    const isEN = lang.startsWith("en");
    const LABEL_MORE = isEN ? "Read more" : "Voir plus";
    const LABEL_LESS = isEN ? "Read less" : "Voir moins";

    // Bouton
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "readmore-toggle";
    btn.textContent = LABEL_MORE;
    btn.setAttribute("aria-expanded", "false");

    btn.addEventListener("click", function(){
      const isHidden = hidden.classList.contains("readmore-hidden");
      hidden.classList.toggle("readmore-hidden");
      btn.textContent = isHidden ? LABEL_LESS : LABEL_MORE;
      btn.setAttribute("aria-expanded", isHidden ? "true" : "false");
    });

    hidden.insertAdjacentElement("afterend", btn);
  });
});
